import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#08070B] mt-20">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo-mark.png" alt="Tazama Africa logo" className="w-9 h-9 rounded-lg object-cover" />
            <span className="font-display font-extrabold text-xl">Tazama <span className="text-[#E50914]">Africa</span></span>
          </div>
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            The home of African cinema, storytelling and creator culture. Stream from 14 nations in 11 languages.
          </p>
        </div>
        <FooterCol title="Explore" links={[["Home", "/"], ["Browse", "/browse"], ["Creators", "/creators"], ["Search", "/search"]]} />
        <FooterCol title="Account" links={[["My Dashboard", "/dashboard"], ["Plans", "/subscriptions"], ["Creator Studio", "/creator/dashboard"], ["Sign in", "/login"]]} />
        <FooterCol title="Regions" links={[["🇿🇼 Zimbabwe", "/browse?country=ZW"], ["🇿🇦 South Africa", "/browse?country=ZA"], ["🇳🇬 Nigeria", "/browse?country=NG"], ["🌍 Diaspora", "/browse?country=AD"]]} />
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Tazama Africa. Proudly built for African stories.
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="font-display font-bold text-sm mb-3 text-white/90">{title}</h4>
    <ul className="space-y-2">
      {links.map(([label, to]) => (
        <li key={label + to}>
          <Link to={to} className="text-sm text-white/50 hover:text-[#E50914] transition-colors">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);
